export default (theme) => ({
    root: {
        marginTop: 5,
    },
});
